export default {
  // Navigation
  'nav.home': 'หน้าแรก',
  'nav.solutions': 'โซลูชัน',
  'nav.features': 'คุณสมบัติ',
  'nav.pricing': 'ราคา',
  'nav.login': 'เข้าสู่ระบบ',
  'nav.getStarted': 'เริ่มต้นใช้งาน',
  
  // Hero Section
  'hero.title': 'แพลตฟอร์มเร่งความเร็วเกมระดับโลก',
  'hero.subtitle': 'โซลูชันเครือข่ายครบวงจรสำหรับผู้จัดจำหน่ายเกมต่างประเทศ',
  'hero.description': 'ใช้ประโยชน์จากเครือข่ายเร่งความเร็วหลายโหนด การจัดการทราฟฟิกแบบไดนามิก และการป้องกันความปลอดภัยครบวงจร เพื่อให้บริการเครือข่ายแบบบูรณาการ ดาวน์โหลด-โต้ตอบ-ป้องกัน',
  'hero.cta.primary': 'เริ่มทดลองใช้ฟรี',
  'hero.cta.secondary': 'ดูตัวอย่าง',
  
  // Stats
  'stats.latency': 'การลดความหน่วงเฉลี่ย',
  'stats.conversion': 'อัตราการติดตั้งที่เพิ่มขึ้น',
  'stats.uptime': 'เวลาทำงานของบริการ',
  'stats.nodes': 'โหนดเร่งความเร็วทั่วโลก',
  
  // Solutions
  'solutions.title': 'โซลูชันครบวงจร',
  'solutions.subtitle': 'แก้ไขปัญหาหลักสามประการในการดำเนินงานเกมระดับโลก',
  
  'solutions.download.title': 'เร่งความเร็วการดาวน์โหลดอัจฉริยะ',
  'solutions.download.desc': 'เครือข่าย CDN หลายโหนดรับประกันการดาวน์โหลดแพ็คเกจเกมที่เสถียรในตลาดเกิดใหม่ เพิ่มอัตราการแปลงการติดตั้ง 18%',
  'solutions.download.feature1': 'เทคโนโลยีดาวน์โหลดต่อจากจุดที่หยุด',
  'solutions.download.feature2': 'การเลือกเส้นทางอัจฉริยะ',
  'solutions.download.feature3': 'ดาวน์โหลดจากหลายแหล่ง',
  
  'solutions.interaction.title': 'การโต้ตอบความหน่วงต่ำ',
  'solutions.interaction.desc': 'การเพิ่มประสิทธิภาพความหน่วงระดับมิลลิวินาทีสำหรับการต่อสู้ข้ามเซิร์ฟเวอร์และทัวร์นาเมนต์ระดับโลก เพิ่มประสบการณ์เกมแข่งขัน',
  'solutions.interaction.feature1': 'การจัดการทราฟฟิกแบบไดนามิก',
  'solutions.interaction.feature2': 'การเพิ่มประสิทธิภาพโปรโตคอล',
  'solutions.interaction.feature3': 'การตรวจสอบแบบเรียลไทม์',
  
  'solutions.security.title': 'การป้องกันความปลอดภัยครบวงจร',
  'solutions.security.desc': 'กลไกป้องกันการโจมตี DDoS และ CC ขั้นสูง รับประกันความพร้อมใช้งานเซิร์ฟเวอร์ 99.99%',
  'solutions.security.feature1': 'การตรวจจับภัยคุกคามอัจฉริยะ',
  'solutions.security.feature2': 'ระบบป้องกันหลายชั้น',
  'solutions.security.feature3': 'การตรวจสอบความปลอดภัย 24/7',
  
  // Features
  'features.title': 'คุณสมบัติแพลตฟอร์ม',
  'features.subtitle': 'ความสามารถอันทรงพลังที่ขับเคลื่อนความสำเร็จเกมระดับโลกของคุณ',
  
  'features.network.title': 'เครือข่ายเร่งความเร็วทั่วโลก',
  'features.network.desc': 'มากกว่า 500 โหนดใน 6 ทวีป ครอบคลุมตลาดเกมหลักทั้งหมด',
  
  'features.analytics.title': 'แดชบอร์ดวิเคราะห์แบบเรียลไทม์',
  'features.analytics.desc': 'ข้อมูลเชิงลึกที่ครอบคลุมสำหรับประสิทธิภาพเครือข่ายและประสบการณ์ผู้ใช้',
  
  'features.api.title': 'API ที่เป็นมิตรกับนักพัฒนา',
  'features.api.desc': 'การรวมระบบง่ายดายด้วย RESTful API และเอกสารที่ครอบคลุม',
  
  'features.support.title': 'การสนับสนุนทางเทคนิค 24/7',
  'features.support.desc': 'ทีมสนับสนุนเฉพาะพร้อมให้บริการตลอดเวลา',
  
  'features.scalability.title': 'โครงสร้างพื้นฐานปรับขนาดอัตโนมัติ',
  'features.scalability.desc': 'ปรับทรัพยากรโดยอัตโนมัติตามความต้องการทราฟฟิก',
  
  'features.compliance.title': 'การปฏิบัติตามกฎระเบียบทั่วโลก',
  'features.compliance.desc': 'เป็นไปตามกฎระเบียบการคุ้มครองข้อมูลในภูมิภาคต่างๆ',
  
  // Pricing
  'pricing.title': 'แผนราคาที่ยืดหยุ่น',
  'pricing.subtitle': 'เลือกแผนที่สมบูรณ์แบบสำหรับธุรกิจเกมของคุณ',
  
  'pricing.starter.name': 'เริ่มต้น',
  'pricing.starter.price': '$299',
  'pricing.starter.period': '/เดือน',
  'pricing.starter.desc': 'เหมาะสำหรับนักพัฒนาเกมอิสระ',
  'pricing.starter.feature1': 'แบนด์วิดท์สูงสุด 100GB',
  'pricing.starter.feature2': '50 โหนดเร่งความเร็ว',
  'pricing.starter.feature3': 'การป้องกัน DDoS พื้นฐาน',
  'pricing.starter.feature4': 'การสนับสนุนทางอีเมล',
  'pricing.starter.feature5': 'การเข้าถึง API',
  
  'pricing.professional.name': 'มืออาชีพ',
  'pricing.professional.price': '$999',
  'pricing.professional.period': '/เดือน',
  'pricing.professional.desc': 'เหมาะสำหรับสตูดิโอเกมที่กำลังเติบโต',
  'pricing.professional.feature1': 'แบนด์วิดท์สูงสุด 1TB',
  'pricing.professional.feature2': '200 โหนดเร่งความเร็ว',
  'pricing.professional.feature3': 'การป้องกัน DDoS ขั้นสูง',
  'pricing.professional.feature4': 'การสนับสนุนลำดับความสำคัญ',
  'pricing.professional.feature5': 'การวิเคราะห์ที่กำหนดเอง',
  'pricing.professional.feature6': 'ผู้จัดการบัญชีเฉพาะ',
  
  'pricing.enterprise.name': 'องค์กร',
  'pricing.enterprise.price': 'กำหนดเอง',
  'pricing.enterprise.period': '',
  'pricing.enterprise.desc': 'สำหรับผู้จัดจำหน่ายเกมขนาดใหญ่',
  'pricing.enterprise.feature1': 'แบนด์วิดท์ไม่จำกัด',
  'pricing.enterprise.feature2': 'มากกว่า 500 โหนดเร่งความเร็ว',
  'pricing.enterprise.feature3': 'ความปลอดภัยระดับองค์กร',
  'pricing.enterprise.feature4': 'การสนับสนุนเฉพาะ 24/7',
  'pricing.enterprise.feature5': 'การรวมระบบที่กำหนดเอง',
  'pricing.enterprise.feature6': 'การรับประกัน SLA',
  'pricing.enterprise.feature7': 'โซลูชัน White-label',
  
  'pricing.cta': 'เลือกแผน',
  'pricing.popular': 'ยอดนิยม',
  
  // CTA Section
  'cta.title': 'พร้อมที่จะเร่งความสำเร็จเกมระดับโลกของคุณหรือยัง?',
  'cta.description': 'เข้าร่วมกับผู้จัดจำหน่ายเกมหลายร้อยรายทั่วโลกที่ไว้วางใจ Elephant Tech สำหรับโครงสร้างพื้นฐานเครือข่าย',
  'cta.button': 'เริ่มทดลองใช้ฟรี',
  
  // Footer
  'footer.product': 'ผลิตภัณฑ์',
  'footer.solutions': 'โซลูชัน',
  'footer.features': 'คุณสมบัติ',
  'footer.pricing': 'ราคา',
  'footer.documentation': 'เอกสาร',
  
  'footer.company': 'บริษัท',
  'footer.about': 'เกี่ยวกับเรา',
  'footer.careers': 'อาชีพ',
  'footer.blog': 'บล็อก',
  'footer.press': 'ข่าวประชาสัมพันธ์',
  
  'footer.resources': 'ทรัพยากร',
  'footer.help': 'ศูนย์ช่วยเหลือ',
  'footer.api': 'เอกสาร API',
  'footer.status': 'สถานะระบบ',
  'footer.security': 'ความปลอดภัย',
  
  'footer.legal': 'กฎหมาย',
  'footer.privacy': 'นโยบายความเป็นส่วนตัว',
  'footer.terms': 'ข้อกำหนดการให้บริการ',
  'footer.compliance': 'การปฏิบัติตามกฎระเบียบ',
  
  'footer.copyright': '© 2024 Elephant Tech Limited. สงวนลิขสิทธิ์',
  'footer.poweredBy': 'ขับเคลื่อนโดย Readdy',
  
  // Login Page
  'login.title': 'ยินดีต้อนรับกลับ',
  'login.subtitle': 'เข้าสู่ระบบบัญชีองค์กรของคุณ',
  'login.email': 'อีเมล',
  'login.password': 'รหัสผ่าน',
  'login.remember': 'จดจำฉัน',
  'login.forgot': 'ลืมรหัสผ่าน?',
  'login.submit': 'เข้าสู่ระบบ',
  'login.noAccount': 'ยังไม่มีบัญชี?',
  'login.contact': 'ติดต่อฝ่ายขาย',
  'login.or': 'หรือดำเนินการต่อด้วย',
  'login.google': 'Google',
  'login.microsoft': 'Microsoft',
  'login.selectedPlan': 'แผนที่เลือก',
};
